import React, { useEffect } from 'react';
import { AbdmProvider, useAbdm } from './context/AbdmContext';
import { LoginForm } from './steps/LoginForm';
import { AuthTypeSelector } from './steps/AuthTypeSelector';
import { OTPVerifier } from './steps/OTPVerifier';
import { AccountSelector } from './steps/AccountSelector';
import { ABHACreator } from './steps/ABHACreator';
import { FaceAuthEnroll } from './steps/FaceAuthEnroll';
import { FaceAuthLogin } from './steps/FaceAuthLogin';
import { FindAbhaByMobile } from './steps/FindAbhaByMobile';
import { AadhaarEnrollForm } from './steps/AadhaarEnrollForm';
import { SuccessView } from './steps/SuccessView';
import { ProgressSteps } from './shared/ProgressSteps';
import { OrgInfo } from './shared/OrgInfo';
import "../App.css";

const AppContent: React.FC = () => {
    const { state, dispatch } = useAbdm();
    const { currentStep, authData } = state;

    useEffect(() => {
        // Load auth from localStorage on mount
        const saved = localStorage.getItem('abdm_auth_data');
        if (saved && !authData) {
            try {
                const parsed = JSON.parse(saved);
                dispatch({ type: 'SET_AUTH_DATA', payload: parsed });
                dispatch({ type: 'SET_STEP', payload: 'authType' });
            } catch {
                localStorage.removeItem('abdm_auth_data');
            }
        }
    }, [dispatch, authData]);

    const renderStep = () => {
        switch (currentStep) {
            case 'login': return <LoginForm />;
            case 'authType': return <AuthTypeSelector />;
            case 'otpVerify': return <OTPVerifier />;
            case 'userSelect': return <AccountSelector />;
            case 'abhaCreate': return <ABHACreator />;
            case 'faceAuthEnroll': return <FaceAuthEnroll />;
            case 'faceAuthLogin': return <FaceAuthLogin />;
            case 'findAbhaByMobile': return <FindAbhaByMobile />;
            case 'aadhaarEnroll': return <AadhaarEnrollForm />;
            case 'success': return <SuccessView />;
            default: return <LoginForm />;
        }
    };

    return (
        <div className="app">
            <header className="app-header">
                <h1>🏥 Cift Health ABDM</h1>
                <p>Secure & Seamless Health ID Management</p>
            </header>
            <br />
            {authData && <OrgInfo />}
            {authData && <ProgressSteps />}
            <main className="content">{renderStep()}</main>
            <footer className="app-footer">
                <p>&copy; 2025 Cift Health ABDM Interface | <code>v1.0</code></p>
            </footer>
        </div>
    );
};

const App: React.FC = () => (
    <AbdmProvider>
        <AppContent />
    </AbdmProvider>
);

export default App;